import React, { useState, useEffect } from "react";
import { fetchImages, deleteImage, AddWebsite } from "../../apis/color-region";
import { API } from "../../apis/constants";
import DeleteIcon from '@mui/icons-material/Delete';
import { Toast } from "../../components/alert";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
    Menu,
    MenuItem,
} from "@mui/material";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from "react-router-dom";

const ColorMap = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [selectedImageId, setSelectedImageId] = useState(null);
    const [updateModalVisible, setUpdateModalVisible] = useState(false);
    const [updateImage, setUpdateImage] = useState(null);
    const [websiteUrl, setWebsiteUrl] = useState("");

    const fetchRegionsData = async () => {
        try {
            setLoading(true);
            const response = await fetchImages("/api/color-pictures", "GET");
            setData(response);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRegionsData();
    }, []);

    const handleDelete = async (id) => {
        try {
            await deleteImage(`/api/color-pictures/${id}`, 'DELETE');
            Toast('success', 'Image deleted successfully');
            setData((prevData) => prevData.filter((item) => item.id !== id));
            setDeleteModalVisible(false);
        } catch (error) {
            console.error("Error deleting image:", error);
            Toast('error', 'Please try again');
        }
    };

    const openDeleteModal = (id) => {
        setSelectedImageId(id);
        setDeleteModalVisible(true);

    };

    const closeDeleteModal = () => {
        setDeleteModalVisible(false);
        setSelectedImageId(null);
    };

    const handleImage = () => {
        navigate('/edit-image/image/new');
    };

    const [previewModalVisible, setPreviewModalVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const openPreviewModal = (item) => {
        setPreviewImage(item);
        setPreviewModalVisible(true);
    };

    const closePreviewModal = () => {
        setPreviewModalVisible(false);
        setPreviewImage(null);
    };

    const openUpdateModal = (item) => {
        setWebsiteUrl(item.website)
        setUpdateImage(item);
        setUpdateModalVisible(true);
    };

    const closeUpdateModal = () => {
        setWebsiteUrl('')
        setUpdateModalVisible(false);
        setUpdateImage(null);
    };

    const handleUpdateSubmit = async () => {
        await AddWebsite(`/api/color-pictures/${updateImage.id}`, { website: websiteUrl }, 'PUT')
        await fetchRegionsData()
        closeUpdateModal();

        Toast('success', 'Website Added successfully!');
    };
    function isValidUrl(url) {
        if (!url) return true;
        try {
            const parsed = new URL(url);
            return (
                (parsed.protocol === "http:" || parsed.protocol === "https:") &&
                !/https?:\/\//.test(parsed.pathname + parsed.search + parsed.hash)
            );
        } catch {
            return false;
        }
    }

    const isUrlValid = isValidUrl(websiteUrl);

    return (
        <Box sx={{ padding: "5px" }}>
            <Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 700, color: "#C84B96" }}>
                    Color Regions
                </Typography>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: '#C84B96',
                        color: '#fff',
                        borderRadius: 2,
                        textTransform: 'capitalize',
                        fontWeight: 600,
                        boxShadow: '0 2px 8px rgba(200,75,150,0.15)',
                        '&:hover': {
                            backgroundColor: '#9B3A73',
                        },
                    }}
                    onClick={handleImage}
                >
                    Add Image
                </Button>
            </Box>
            <Grid container spacing={3}>
                {loading ? (
                    Array.from({ length: 6 }).map((_, index) => (
                        <Grid item xs={12} sm={6} md={2} key={index}>
                            <Box
                                sx={{
                                    width: "150px",
                                    height: "150px",
                                    borderRadius: "50%",
                                    backgroundColor: "#e0e0e0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto"
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        </Grid>
                    ))
                ) : data.length > 0 ? (
                    data.map((item) => (
                        <Grid item xs={12} sm={6} md={2} key={item.id}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                "&:hover": {
                                    transform: "scale(1.05)",
                                    transition: "transform 0.2s",
                                },
                            }}>
                            <Box
                                sx={{
                                    width: "200px",
                                    textAlign: "center",
                                    position: "relative",
                                    border: "1px solid #ddd",
                                    borderRadius: "12px",
                                    padding: "10px",
                                    background: "#fff",
                                    boxShadow: "0 2px 8px rgba(200,75,150,0.07)",
                                    transition: "box-shadow 0.2s",
                                    "&:hover": {
                                        boxShadow: "0 4px 16px rgba(200,75,150,0.15)",
                                    },
                                }}
                            >
                                {/* Place MoreOptionsMenu absolutely in the top right */}
                                <MoreOptionsMenu
                                    item={item}
                                    onDelete={openDeleteModal}
                                    onUpdate={openUpdateModal}
                                    sx={{
                                        marginLeft: "10px",
                                    }}
                                />
                                <Box
                                    sx={{
                                        position: "relative",
                                        width: "100px",
                                        height: "100px",
                                        margin: "0 auto 10px auto",
                                        borderRadius: "50%",
                                        overflow: "hidden",
                                        boxShadow: "0 2px 8px rgba(200,75,150,0.10)",
                                        "&:hover .delete-backdrop": {
                                            opacity: 1,
                                        },
                                    }}
                                >
                                    <img
                                        src={API.baseUrl + item.image_path}
                                        alt={item.title}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            display: "block",
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    ))
                ) : (
                    <Grid item xs={12}>
                        <Box sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "180px",
                            background: "#fff",
                            borderRadius: 2,
                            boxShadow: "0 2px 8px rgba(200,75,150,0.07)",
                        }}>
                            <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
                                No Images Found
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Click "Add Image" to upload your first color region image.
                            </Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>

            {/* Delete Confirmation Modal */}
            <Dialog
                open={deleteModalVisible}
                onClose={closeDeleteModal}
                aria-labelledby="delete-dialog-title"
                aria-describedby="delete-dialog-description"
            >
                <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-dialog-description">
                        Are you sure you want to delete this image?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDeleteModal} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => handleDelete(selectedImageId)}
                        color="error"
                        variant="contained"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Image Preview Modal */}
            <Dialog
                open={previewModalVisible}
                onClose={closePreviewModal}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        background: "rgba(255,255,255,0.97)",
                        boxShadow: 24,
                        borderRadius: 2,
                        position: "relative",
                    }
                }}
                BackdropProps={{
                    sx: {
                        backgroundColor: "rgba(0,0,0,0.7)",
                    }
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={closePreviewModal}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                        zIndex: 2,
                    }}
                >
                    <span style={{ fontSize: 24, fontWeight: 'bold' }}>×</span>
                </IconButton>
                <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 300 }}>
                    {previewImage && (
                        <img
                            src={API.baseUrl + previewImage.image_path}
                            alt={previewImage.title}
                            style={{
                                maxWidth: "100%",
                                maxHeight: "350px",
                                borderRadius: "12px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>

            {/* Update Details Modal */}
            <Dialog
                open={updateModalVisible}
                onClose={closeUpdateModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Add Website </DialogTitle>
                <DialogContent>
                    <input
                        type="text"
                        placeholder="Enter website URL"
                        style={{
                            width: "100%",
                            minHeight: "100px",
                            marginTop: "16px",
                            padding: "8px",
                            fontSize: "16px",
                            borderRadius: "4px",
                            border: !isUrlValid && websiteUrl !== "" ? "2px solid red" : "1px solid #ccc",
                            resize: "vertical"
                        }}
                        value={websiteUrl}
                        onChange={(e) => setWebsiteUrl(e.target.value)}
                    />
                    {!isUrlValid && websiteUrl !== "" && (
                        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                            Please enter a valid URL
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeUpdateModal} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleUpdateSubmit}
                        color="primary"
                        variant="contained"
                        disabled={!websiteUrl || !isUrlValid}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

// Add this component just above export default ColorMap;

const MoreOptionsMenu = ({ item, onDelete, onUpdate }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        handleClose();
        onDelete(item.id);
    };

    const handleUpdate = () => {
        handleClose();
        onUpdate(item);
    };

    return (
        <>
            <IconButton
                sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    color: "#C84B96",
                    boxShadow: "0 1px 4px rgba(200,75,150,0.08)",
                    "&:hover": {
                        background: "#FCE4EC",
                    },
                }}
                onClick={handleOpen}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={handleUpdate}>Add website</MenuItem>
                <MenuItem onClick={handleDelete}>

                    Delete
                    <DeleteIcon />
                </MenuItem>
            </Menu>
        </>
    );
};

export default ColorMap;